export default "__VITE_ASSET__DVIGaW2s__"